"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChunk = exports.createChunk = void 0;
function createChunk(from, props, ...children) {
    const chunk = { props: props || {}, children };
    if (typeof from === "string") {
        chunk.tagName = from;
    }
    else {
        chunk.rule = from;
    }
    return chunk;
}
exports.createChunk = createChunk;
function isChunk(obj) {
    return typeof obj !== "string" && "props" in obj && "children" in obj;
}
exports.isChunk = isChunk;
